import { IApiError, IApiResponseError } from '@/models/apiError.model';
import { ResponseStatusCodes } from '@/constants/common';
import { isHttpClientError } from './httpClient';

const formatApiError = (err: unknown): IApiError => {
  const error: IApiError = {
    status: ResponseStatusCodes.SOMETHING_WRONG,
    message: (err as Error)?.message || 'Error',
    code: undefined,
    errors: null,
  };

  if (isHttpClientError(err)) {
    const apiResponse = err.response?.data as IApiResponseError;
    error.status = err.response?.status || ResponseStatusCodes.SERVER_ERROR;
    error.message = apiResponse?.message || 'Error';
    error.code = apiResponse?.errors?.code?.[0];

    if (apiResponse?.errors && Object.keys(apiResponse.errors).length) {
      error.errors = Object.keys(apiResponse.errors).reduce((acc, key) => {
        const raw = apiResponse.errors?.[key]?.[0];
        let fieldMessage: string;
        if (typeof raw === 'string' && raw.trim()) {
          fieldMessage = raw;
        } else if (
          raw &&
          typeof raw === 'object' &&
          'message' in raw &&
          typeof (raw as { message: unknown }).message === 'string'
        ) {
          fieldMessage = (raw as { message: string }).message;
        } else {
          fieldMessage = error.message;
        }
        acc[key] = fieldMessage;
        return acc;
      }, {} as Record<string, string>);
    }
  }

  return error;
};

export default formatApiError;
